import { render, staticRenderFns } from "./BugPreview.vue?vue&type=template&id=e2a782d4&scoped=true"
import script from "./BugPreview.vue?vue&type=script&lang=js"
export * from "./BugPreview.vue?vue&type=script&lang=js"
import style0 from "./BugPreview.vue?vue&type=style&index=0&id=e2a782d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a782d4",
  null
  
)

export default component.exports